import styled from "styled-components";

// variables

const marginVar = 30;
const paddingVar = 24;
const heightVar = 110;

export const TooltipContainer = styled.div`
  display: flex;
  position: relative;
  cursor: pointer;
  align-items: center;
`;

const calculatePosition = (
  position: string
): {
  before?: any;
  bottom?: string;
  top?: string;
  left?: number | string;
  right?: number | string;
  transform?: string;
} => {
  if (position === "top") {
    return {
      top: `calc(${paddingVar + heightVar}px * -1)`,
      left: 0,
      before: `
        top: 100%;
        border-top-color: #00AFEE;
      `,
    };
  }

  if (position === "right") {
    return {
      left: "calc(100% + 30px)",
      top: "50%",
      transform: "translateX(0) translateY(-50%)",
      before: `
        left: calc(6px * -1);
        top: 50%;
        transform: translateX(0) translateY(-50%);
        border-right-color: #00AFEE;
      `,
    };
  }

  if (position === "left") {
    return {
      top: "50%",
      left: "auto",
      right: "calc(100% + 30px)",
      transform: "translateX(0) translateY(-50%)",
      before: `
        left: auto;
        top: 50%;
        right: calc(6px * -2);
        transform: translateX(0) translateY(-50%);
        border-left-color: #00AFEE;
      `,
    };
  }
  if (position === "bottom") {
    return {
      bottom: `calc(${marginVar + heightVar}px * -1)`,
      transform: "translateX(-50%)",
      before: `
        bottom: 100%;
        border-bottom-color: #00AFEE;
      `,
    };
  }

  return {
    bottom: "0px",
    top: "0px",
  };
};

export const TooltipClose = styled.button`
  display: flex;
  justify-content: flex-end;
  border: none;
  background: none;
  color: #fff;
  cursor: pointer;
`;

export const TooltipContent = styled.div`
  font-size: 16px;
  color: #fff;
  justify-content: center;
  align-items: center;
  flex: 1;
  display: flex;
`;
export const TooltipTip = styled.div<{
  position: "top" | "bottom" | "left" | "right";
}>`
  position: absolute;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  left: 50%;
  padding: 6px;
  border-radius: 4px;
  background: #00afee;
  z-index: 100;
  width: 328px;
  height: ${heightVar}px;
  transform: ${(props) => calculatePosition(props.position).transform};
  top: ${(props) => calculatePosition(props.position).top};
  left: ${(props) => calculatePosition(props.position).left};
  right: ${(props) => calculatePosition(props.position).right};
  bottom: ${(props) => calculatePosition(props.position).bottom};
  &::before {
    content: " ";
    left: 50%;
    border: solid transparent;
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-width: 6px;
    margin-left: calc(6px * -1);
    ${(props) => calculatePosition(props.position).before}
  }
`;
